import { TableColumn } from '@dtk/ui-components';

export const TableColumnBlok = ({ ...props }) => {
  return <TableColumn data={props} />;
};
